import { render, staticRenderFns } from "./BusChanges.vue?vue&type=template&id=1193ebe0&scoped=true&"
import script from "./BusChanges.vue?vue&type=script&lang=js&"
export * from "./BusChanges.vue?vue&type=script&lang=js&"
import style0 from "./BusChanges.vue?vue&type=style&index=0&id=1193ebe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193ebe0",
  null
  
)

export default component.exports